document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("bdPhotoModal");
  if (!modal) return;

  // ── Variant IDs ── TODO: Shopify-Varianten-IDs eintragen sobald Produkte erstellt
  // Format: { "Typ|Farbe": variantId }
  const BD_PHOTO_VARIANTS = {
    "essilor|Grau":               53757131784519,
    "essilor|Braun":              53757131817287,
    "essilor|Grün":               53757131850055,
    "essilor|Sapphire (Blau)":    53757131882823,
    "essilor|Amethyst (Violett)": 53757131915591,
    "essilor|Emerald (Grün)":     53757131948359,
    "essilor|Amber (Braun)":      53757131981127,
    "essilor|Ruby (Rot)":         53757132013895,
    "colormatic|Grau":            53757137453383,
    "colormatic|Braun":           53757137486151,
  };

  const stepType  = document.getElementById("bdPhotoStepType");
  const stepColor = document.getElementById("bdPhotoStepColor");
  const colorBack = document.getElementById("bdPhotoColorBack");

  const productForm =
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector("product-form form") ||
    document.querySelector('form[action^="/cart/add"]');

  let selectedType    = null;
  let selectedPrice   = null;
  let selectedName    = null;
  let selectedColor   = null;
  let selectedVariant = null;

  const basePrice = modal.dataset.basePrice || "0";
  const summary = window.BdWizSummary && window.BdWizSummary.mount("bdPhotoModal", basePrice, bdT("frame", "Fassung"));

  // Open trigger (delegated, works regardless of productForm)
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-open-photo-modal]")) {
      e.preventDefault();
      openModal();
    }
  });

  if (!productForm) return;

  // ── Helpers ────────────────────────────────────────────

  function hideAllSteps() {
    [stepType, stepColor].forEach(s => s && (s.style.display = "none"));
  }

  function openModal() {
    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
    if (summary) summary.reset();
    if (bdRxStep) bdRxStep.hide();
    showStepType();
  }

  function closeModal() {
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
  }

  function showStepType() {
    hideAllSteps();
    if (stepType) stepType.style.display = "block";
    selectedType = null; selectedPrice = null; selectedName = null;
    selectedColor = null; selectedVariant = null;
  }

  function showStepColor() {
    hideAllSteps();
    if (stepColor) stepColor.style.display = "block";

    const essilorGrid    = document.getElementById("bdPhotoEssilorColors");
    const colormaticGrid = document.getElementById("bdPhotoColormaticColors");
    const hint           = document.getElementById("bdPhotoColorHint");

    if (selectedType === "essilor") {
      if (essilorGrid)    essilorGrid.style.display    = "grid";
      if (colormaticGrid) colormaticGrid.style.display = "none";
      if (hint) hint.textContent = bdT("colors_8", "8 Farbtöne – abgestimmt auf deinen Look.");
    } else {
      if (essilorGrid)    essilorGrid.style.display    = "none";
      if (colormaticGrid) colormaticGrid.style.display = "grid";
      if (hint) hint.textContent = bdT("colors_2", "2 klassische Farbtöne.");
    }
  }

  // ── Sehstärke übermitteln (shared step) ─────────────────

  const bdRxStep = window.BdRxStep && window.BdRxStep.mount({
    prefix: "bdPhotoRx",
    onBack: showStepColor,
    onComplete: function (rxProps, fileInput) {
      const properties = Object.assign({
        "Gläserpaket": selectedName,
        "Glasfarbe": selectedColor,
        "Gläserpaket Aufpreis (CHF)": selectedPrice,
      }, rxProps);
      closeModal();
      window.BdCartEngine.submit({
        productForm: productForm,
        properties: properties,
        fileInput: fileInput,
        addonVariantId: selectedVariant,
      });
    },
  });

  // ── Close ──────────────────────────────────────────────

  modal.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest("[data-bd-photo-close]")) closeModal();
  });

  // ── Step 1: Linsentyp (tap-to-advance) ────────────────

  document.querySelectorAll("#bdPhotoTypeList .bd-wiz-row").forEach(function (row) {
    row.addEventListener("click", function () {
      selectedType  = row.getAttribute("data-photo-type");
      selectedPrice = row.getAttribute("data-photo-price");
      selectedName  = row.getAttribute("data-photo-name");
      if (summary) summary.set("lens", selectedName, selectedPrice);
      showStepColor();
    });
  });

  // ── Step 2: Farbe (tap-to-advance) ────────────────────

  if (colorBack) colorBack.addEventListener("click", showStepType);

  document.querySelectorAll(".bd-photo-colorBtn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      selectedColor   = btn.getAttribute("data-photo-color");
      const key       = selectedType + "|" + selectedColor;
      selectedVariant = BD_PHOTO_VARIANTS[key] || null;
      hideAllSteps();
      if (bdRxStep) bdRxStep.show();
    });
  });
});
